import React from 'react';

const Preloader = () => {
  return (
    <div className="preloader-div">
      {/* Add your preloader UI here */}
      <h2 className="loading-header">Loading... </h2>
    </div>
  );
};

export default Preloader;
